export const formatDateMMDDYYYY = (date: Date, monthFormat: MonthFormat) => {
  const formattedDate = date.toLocaleDateString("en-US", {
    timeZone: "Europe/London",
    year: "numeric",
    month: monthFormat,
    day: "2-digit",
  })
  return formattedDate
}

export enum MonthFormat {
  Numeric = "numeric",
  TwoDigit = "2-digit",
  Long = "long",
  Short = "short",
  Narrow = "narrow",
}
